import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs/Observable";

@Injectable()
export class PusherService {

  private static getApiUrl(instanceId: string) {
    return `https://${instanceId}.pushnotifications.pusher.com/publish_api/v1/instances/${instanceId}/publishes`;
  }

  constructor(private _http: HttpClient) {
  }

  send(instanceId: string,
       secret: string,
       installationId: string,
       messageBody: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'Bearer ' + secret
    });
    const url = PusherService.getApiUrl(instanceId);
    const body = {
      interests: [installationId],
      apns: {
        aps: {
          alert: {
            title: 'Test push',
            body: messageBody
          },
          badge: 0
        }
      }
    };
    console.log(`[PusherService.send]: headers`, headers);
    console.log(`[PusherService.send]: url`, url);
    console.log(`[PusherService.send]: body`, body);
    return this._http.post(url, body, {headers});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/pusher.service.ts